import { NgModule } from '@angular/core'
import {
  translationChunksConfig,
  translationsDe,
  translationsEn,
  translationsJa,
  translationsZh
} from '@spartacus/assets'
import { defaultB2BCheckoutConfig } from '@spartacus/checkout/b2b/root'
import { FeaturesConfig, I18nConfig, provideConfig } from '@spartacus/core'
import { defaultB2bOccConfig } from '@spartacus/setup'
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront'
import { EbSiteContextFallbackValues } from '../features/site-context/interfaces/eb-site-context.interface'

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      i18n: {
        resources: {
          en: translationsEn,
          ja: translationsJa,
          de: translationsDe,
          zh: translationsZh
        },
        chunks: translationChunksConfig,
        fallbackLang: EbSiteContextFallbackValues.LANGUAGE
      }
    } as I18nConfig),
    provideConfig({
      features: {
        level: '5.0'
      }
    } as FeaturesConfig),
    provideConfig(defaultB2bOccConfig),
    provideConfig(defaultB2BCheckoutConfig)
  ]
})
export class SpartacusConfigurationModule {}
